import { useEffect } from 'react';
import { prop } from 'ramda';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { useUserSelector, useAppSelector } from 'js/store/hooks';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';

import * as server from './server';
import * as helpers from '../helpers';
import { PERIOD } from '../constants';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';

export const useFetchComponent = ({ setError }) => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const getErrorMessage = useGetErrorMessage();
    const { period = PERIOD.LAST_DAY, topLength = 10 } = useComponentConfig();
    const currency = useUserSelector(prop('currencyCode'));
    const casino = useAppSelector(prop('casinoName'));

    useEffect(() => {
        if (!isMounted() || !currency) {
            return;
        }

        dispatch(actions.toggleLoading(true));

        (async () => {
            try {
                const { startDate, endDate } = helpers.getPeriodDates(period);
                const response = await server.getTopWinners({
                    startDate, endDate, currency, casino, topLength
                });
                const topWinners = helpers.parseTopWinners(response?.data?.topWinners);

                isMounted() && dispatch(actions.setTopWinnersData(topWinners));
            } catch (error) {
                isMounted() && setError(getErrorMessage(error));
            } finally {
                isMounted() && dispatch(actions.toggleLoading(false));
            }
        })();
    }, [dispatch, isMounted, getErrorMessage, period, setError, casino, currency, topLength]);
};
